import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

import { BrandedAuthLayout } from '@/layouts/BrandedAuthLayout';
import { Button } from '@marine/ui/button';

export function TenantResetPasswordChangedPage() {
  return (
    <BrandedAuthLayout variant="dealer">
      <div className="block w-full space-y-5 text-center">
        <div className="flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-green-500/10 text-green-600 dark:text-green-400">
            <CheckCircle2 className="h-7 w-7" />
          </div>
        </div>

        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">
            Password updated
          </h1>
          <p className="text-sm text-muted-foreground">
            Your password has been reset. Sign in with your new password to
            continue.
          </p>
        </div>

        <Button asChild className="w-full">
          <Link to="/login">Sign in</Link>
        </Button>
      </div>
    </BrandedAuthLayout>
  );
}
